export default __webpack_public_path__ + "static/media/poweredByCuddles.769c4666.svg";